import PropTypes from 'prop-types';
import React from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import EventDetailModal from './EventDetailModalContainer';
import CalendarItem from './CalendarItem';
import { EVENT_COLORS, GROUP_COLORS } from './EventStyles';

BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
function findById(value) {
  return value.id === Number(this);
}

// "related_group_events": [
//                 {
//                     "id": 179,
//                     "group": 28,
//                     "group_name": "Group 0",
//                     "bids": {
//                         "event": 179,
//                         "queens": 0,
//                         "kings": 10,
//                         "suites": 10,
//                         "state": "IN_PROGRESS",
//                         "bid_count": 7
//                     },
//                     "place": {
//                         "id": "179d001d-809c-4c46-85fc-c2368bd4db6c",
//                         "name": "Red Hat Amphitheater",
//                         "address": "500 S McDowell St",
//                         "city": "Raleigh",
//                         "state": "NC",
//                         "postcode": "27601",
//                         "position": {
//                             "type": "Point",
//                             "coordinates": [
//                                 -78.642796,
//                                 35.773652
//                             ]
//                         },
//                         "place_type": "VENUE",
//                         "image": null,
//                         "tel": "(919) 831-6400"
//                     },
//                     "start": "2017-08-23",
//                     "end": "2017-08-24",
//                     "all_day": false,
//                     "event_type": "stay"
//                 }
//             ],
//             "notes": null,
//             "tour": 14
//         },

function formatRelatedEvent(event, events, parent, filter) {
  if (filter[event.group_name]) {
    return;
  }
  const name = (<CalendarItem event={event} group />);
  const backgroundColor = GROUP_COLORS[event.group % 4];
  events.push({
    id: parent.id,
    title: name,
    start: moment(event.start),
    end: moment(event.end),
    event_type: event.event_type,
    allDay: true,
    backgroundColor,
  });
}
function formatEvent(event, events, filter) {
  // console.log("formatEvent filter -> ", event.event_type, filter[event.event_type]);
  if (event.event_type === 'stay') {
    const relatedEvents = event.related_group_events;
    for (let i = 0, len = relatedEvents.length; i < len; i++) {
      if (!filter[relatedEvents.group]) {
        formatRelatedEvent(relatedEvents[i], events, event, filter);
      }
    }
  } else {
    if (filter[event.event_type]) {
      return;
    }
    const name = (<CalendarItem event={event} />);
    events.push({
      id: event.id,
      title: name,
      start: moment(event.start),
      end: moment(event.end),
      event_type: event.event_type,
      allDay: true,
      backgroundColor: EVENT_COLORS[event.event_type],
    });
  }
}
function eventStyleGetter(event, start, end, isSelected) {
    // console.log(event);
  let backgroundColor = '#26C6DA';
  if (event.backgroundColor) {
    backgroundColor = event.backgroundColor;
  }
  const style = {
    backgroundColor,
    borderRadius: '0px',
    opacity: 0.8,
    border: '0px',
    display: 'block',
  };
  return {
    style,
  };
}

class TourCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      edit: false,
    };
    this.addEvent = this.addEvent.bind(this);
    this.showEvent = this.showEvent.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal() {
    this.setState({
      show: false,
      event: null,
    });
  }
  findEvent(id) {
    if (id === -1) {
      return {
        start: this.state.start,
      };
    }
    const stops = this.props.tour.tour_stops;
    for (let i = 0, len = stops.length; i < len; i++) {
      if (stops[i].id === Number(id)) {
        return this.props.tour.tour_stops[i];
      }
      const idx = stops[i].events.findIndex(findById, id);
      if (idx !== -1) {
        return this.props.tour.tour_stops[i].events[idx];
      }
    }
    console.log('that should not happen... findEvent: ', id);
    return {};
  }
  showEvent(event) {
    if (event) {
      this.setState({
        event: event.id,
        show: true,
        edit: false,
      });
    }
  }
  addEvent(start, readOnly) {
    if (readOnly) {
      this.setState({
        show: false,
      });
      return;
    }
    console.log('Add Event start time: ', start);
    this.setState({
      event: -1,
      show: true,
      start,
      edit: true,
    });
  }

  render() {
    try {
      const events = [];
      const today = moment();
      let tourStart = moment(this.props.tour.start);
      if (today.isSameOrAfter(tourStart)) {
        tourStart = today.toDate();
      } else {
        tourStart = tourStart.toDate();
      }
      this.props.tour.tour_stops.forEach((event) => {
        formatEvent(event, events, this.props.filter);
        if (event.events) {
          for (let i = 0, len = event.events.length; i < len; i++) {
            formatEvent(event.events[i], events, this.props.filter);
          }
        }
      });
      return (
        <div>
          { this.state.show && (
          <EventDetailModal
            event={this.findEvent(this.state.event)}
            show={this.state.show}
            onClose={this.closeModal}
            editing={this.state.edit}
          />
          )}
          <BigCalendar
            selectable
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 600 }}
            eventPropGetter={(eventStyleGetter)}
            onSelectEvent={event => this.showEvent(event)}
            onSelectSlot={slotInfo => this.addEvent(slotInfo.start, this.props.readOnly)}
            defaultDate={tourStart}
          />
        </div>
      );
    } catch (e) {
      console.log('TourCalendar -> ', e);
      return null;
    }
  }
}
TourCalendar.propTypes = {
  tour: PropTypes.object.isRequired,
  filter: PropTypes.object,
};
TourCalendar.defaultProps = {
  filter: {},
};
export default TourCalendar;



// WEBPACK FOOTER //
// src/routes/tours/components/TourCalendar.js